function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#ccc",
  strokeWidth: 3,
  d: "M255 308.571c-90 0-90 17.143-180 17.143M255 342.857c-90 0-90-17.143-180-17.143M435 120c-90 0-90 222.857-180 222.857M435 325.714c-90 0-90 17.143-180 17.143M435 394.286c-90 0-90-51.429-180-51.429M435 462.857c-90 0-90-120-180-120M435 497.143c-90 0-90-154.286-180-154.286M435 531.429c-90 0-90-188.572-180-188.572M435 565.714c-90 0-90-222.857-180-222.857M615 34.286c-90 0-90 85.714-180 85.714M615 68.571c-90 0-90 51.429-180 51.429M615 102.857c-90 0-90 17.143-180 17.143M615 137.143c-90 0-90-17.143-180-17.143M615 171.429c-90 0-90-51.429-180-51.429M615 205.714c-90 0-90-85.714-180-85.714M615 274.286c-90 0-90 51.428-180 51.428M615 308.571c-90 0-90 17.143-180 17.143M615 342.857c-90 0-90-17.143-180-17.143M615 377.143c-90 0-90-51.429-180-51.429M615 445.714c-90 0-90 17.143-180 17.143M615 480c-90 0-90-17.143-180-17.143M795 34.286H615M795 188.571c-90 0-90 17.143-180 17.143M795 222.857c-90 0-90-17.143-180-17.143"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(75 325.714)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#ff7993",
  stroke: "#e66980"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: -20,
  textAnchor: "end",
  fill: "#777",
  fontWeight: 700
}, "19A"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(255 308.571)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#ff7d66",
  stroke: "#e66c58"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "19B"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(255 342.857)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#fa8b36",
  stroke: "#d9782f"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: -20,
  textAnchor: "end",
  fill: "#777",
  fontWeight: 700
}, "20A"));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(435 120)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#e09836",
  stroke: "#c3842f"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: -20,
  textAnchor: "end",
  fill: "#777",
  fontWeight: 700
}, "20B"));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(435 325.714)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#3ab9b7",
  stroke: "#32a09e"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: -20,
  textAnchor: "end",
  fill: "#777",
  fontWeight: 700
}, "20C"));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(435 394.286)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#91a0ff",
  stroke: "#7e8be3"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "20E"));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(435 462.857)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#b993ff",
  stroke: "#a080e3"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: -20,
  textAnchor: "end",
  fill: "#777",
  fontWeight: 700
}, "21A (Delta)"));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(435 497.143)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#ff69ea",
  stroke: "#e45bcb"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21B (Kappa)"));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(435 531.429)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#ff70ce",
  stroke: "#e561b3"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21D (Eta)"));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(435 565.714)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#ff74b3",
  stroke: "#e5659c"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21H (Mu)"));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 34.286)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#cca236",
  stroke: "#b18d2f"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: -20,
  textAnchor: "end",
  fill: "#777",
  fontWeight: 700
}, "20D"));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 68.571)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#a8ae35",
  stroke: "#91972e"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "20F"));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 102.857)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#90b435",
  stroke: "#7d9c2e"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "20I (Alpha)"));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 137.143)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#6abb35",
  stroke: "#5ca22e"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "20J (Gamma)"));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 171.429)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#36bf58",
  stroke: "#2fa64c"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21E (Theta)"));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 205.714)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#37bd83",
  stroke: "#2fa472"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: -20,
  textAnchor: "end",
  fill: "#777",
  fontWeight: 700
}, "21M (Omicron)"));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 274.286)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#3bb8c5",
  stroke: "#339faa"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "20G"));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 308.571)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#3cb5d4",
  stroke: "#349db7"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "20H (Beta)"));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 342.857)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#3eb2e9",
  stroke: "#369bca"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21C (Epsilon)"));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 377.143)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#4facff",
  stroke: "#4595e3"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21F (Iota)"));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 445.714)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#db83ff",
  stroke: "#be72e3"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21I (Delta)"));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(615 480)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#ff68ff",
  stroke: "#de5ae3"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21J (Delta)"));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(795 34.286)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#bba935",
  stroke: "#a2922e"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21G (Lambda)"));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(795 188.571)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#38bc9a",
  stroke: "#30a385"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21K (Omicron)"));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  className: "clades_svg__node",
  transform: "translate(795 222.857)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "clades_svg__node",
  r: 15,
  fill: "#39baaa",
  stroke: "#31a193"
}), /*#__PURE__*/React.createElement("text", {
  dy: ".35em",
  x: 20,
  fill: "#777",
  fontWeight: 700
}, "21L (Omicron)"));

function SvgClades(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "clades_svg__d3-component",
    viewBox: "0 0 1000 600",
    fontFamily: "sans-serif",
    fontSize: "1.25rem"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

export default "assets/clades.e1cc740.svg";
export { SvgClades as ReactComponent };